import React, { useState } from "react";
import {
    Button,
    Modal,
    Form,
    Input,
    Space,
    Row,
    Col,
    Select,
    useForm,
    useModal,
} from "@pankod/refine-antd";
import { Typography } from 'antd';

const { Text } = Typography;


export const CreateEaseBuzzWireCbModal: React.FC<{ refetchTableProps: any; companyDetail: any; easebuzzListingOptions: any }> = (
    {
        refetchTableProps,
        companyDetail,
        easebuzzListingOptions
    }) => {
    const companyId = companyDetail.id;
    const brandName = companyDetail.brandName;

    const [isVerified, setIsVerified] = useState(false);
    const [bankAccountValidationRequestId, setBankAccountValidationRequestId] = useState<string | null>(null);
    const [serviceProviderId, setServiceProviderId] = useState<string | null>(null);

    const {
        modalProps: createEaseBuzzWireModal,
        show: showEaseBuzzWireVaCreationModal,
        close: closeEaseBuzzWireVaCreationModal,
    } = useModal();

    const { formProps } = useForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "verifyConnectedBankingBankAccountDetails",
        metaData: {
            companyId,
            accountNameForValidation: brandName,
        },
        redirect: false,
        onMutationSuccess: (data, variables, context) => {
            const { data: resp } = data;
            setIsVerified(true);
            setServiceProviderId(resp.serviceProviderId);
            setBankAccountValidationRequestId(resp.bankAccountValidationRequestId);
        }
    });

    const {
        formProps: initiateFormProps,
    } = useForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "initiateCorporateOnboardingRequestForEaseBuzzConnectedBanking",
        metaData: {
            companyId,
            bankAccountValidationRequestId,
            serviceProviderId,
            nameOnBank: brandName,
        },
        redirect: false,
        onMutationSuccess: () => {
            refetchTableProps(true);
            cancelEaseBuzzWireVaModal(true);
        },
    });
    createEaseBuzzWireModal.title = "Create EaseBuzz Wire CB";
    createEaseBuzzWireModal.centered = true;
    createEaseBuzzWireModal.width = 800;

    const cancelEaseBuzzWireVaModal = (flag?: boolean) => {
        if (flag) {
            setIsVerified(false);
            setServiceProviderId(null);
            setBankAccountValidationRequestId(null);
            initiateFormProps.form?.resetFields();
        }
        formProps.form?.resetFields();
        closeEaseBuzzWireVaCreationModal();
    };

    return (
        <Space>
            <Button onClick={() => showEaseBuzzWireVaCreationModal()}>
                Create EaseBuzz Wire CB
            </Button>

            <Modal
                {...createEaseBuzzWireModal}
                closable={!isVerified}
                footer={[
                    <Button
                        key="verify"
                        type="primary"
                        disabled={isVerified}
                        onClick={() => {formProps.form?.submit()}}
                    >
                        Verify
                    </Button>,
                    <Button
                        key="back"
                        disabled={isVerified}
                        onClick={() => {cancelEaseBuzzWireVaModal()}}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!isVerified}
                        onClick={() => {
                            initiateFormProps.form?.submit();
                        }}>
                            Save
                    </Button>,
                ]}
            >
                <>
                    <Form
                        {...formProps}
                        layout="vertical"
                        initialValues={{
                            companyId,
                            brandName,
                        }}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="companyId"
                                    label="Company Id"
                                >
                                    <Input
                                        disabled={true}
                                        value={companyId}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="brandName"
                                    label="Brand Name"
                                >
                                    <Input
                                        disabled={true}
                                        value={brandName}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item
                                    label="Service Provider Integration"
                                    name="bankIntegratorId"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select a value",
                                        },
                                    ]}
                                >
                                    <Select
                                        disabled={isVerified}
                                        options={easebuzzListingOptions}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="accountNumber"
                                    label="Account Number"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter the account number",
                                        },
                                    ]}
                                >
                                    <Input disabled={isVerified}/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="ifsc"
                                    label="IFSC Code"
                                    rules={[{ required: true, message: "Please enter the IFSC code" }]}
                                >
                                    <Input disabled={isVerified}/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Form
                        {...initiateFormProps}
                        layout="vertical"
                    >
                        <Row gutter={16}>
                            <Col span={10}>
                                <Form.Item
                                    name="key"
                                    label="Key"
                                    rules={[{ required: true, message: "Please enter the key" }]}
                                >
                                    <Input disabled={!isVerified}/>
                                </Form.Item>
                            </Col>
                            <Col span={10}>
                                <Form.Item
                                    name="salt"
                                    label="Salt"
                                    rules={[{ required: true, message: "Please enter the salt" }]}
                                >
                                    <Input disabled={!isVerified}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Col span={24}>
                            <Text>Note: Please verify the Account and IFSC code to create account.</Text>
                        </Col>
                    </Form>
                </>
            </Modal>
        </Space>
    );
};